
import Ws from './ws';
import WsImage from './wsImage';
import wsTeste from './wsTeste';
import Endpoints from './endpoints';
import router from '../../router/index.js';
import idb from '@/store/services/idb';

export const WsCalls = {
    callMethodWS
};

function callMethodWS(method, endpoint, config, parametros = null, headers = null) {
    if(window.navigator.onLine){
        return new Promise(async (resolve, reject) => {
            var browser = getInfos();
            var os_id = browser.os_id;
            delete browser.os_id;
            config.os_id = os_id;
            config.browser = browser;
            var dados = Endpoints(endpoint);

            if(method == 'POST'){
                Ws(config).post(
                    dados.modulo+'/'+dados.versao+'/'+dados.endpoint,
                    parametros
                ).then(response => {
                    resolve(response);
                }, error => {
                    reject(error);
                });
            } else if(method == 'GET'){ // GET parâmetros na URL
                Ws(config, headers).get(
                    dados.modulo+'/'+dados.versao+'/'+dados.endpoint+ (parametros != null ? ('/'+parametros) : '')
                ).then(response => {
                    resolve(response);
                }, error => {
                    reject(error);
                });
            } else if(method == 'PUT'){
                Ws(config).put(
                    dados.modulo+'/'+dados.versao+'/'+dados.endpoint,
                    parametros
                ).then(response => {
                    resolve(response);
                }, error => {
                    reject(error);
                });
            } else if(method == 'PATCH'){
                Ws(config).patch(
                    dados.modulo+'/'+dados.versao+'/'+dados.endpoint,
                    parametros
                ).then(response => {
                    resolve(response);
                }, error => {
                    reject(error);
                });
            } else if(method == 'DELETE'){
                Ws(config, headers).delete(
                    dados.modulo+'/'+dados.versao+'/'+dados.endpoint, 
                    {
                        data: parametros
                    }
                ).then(response => {
                    resolve(response);
                }, error => {
                    reject(error);
                });
            } else if(method == 'IMAGE'){
                // let images = await idb.getData('images');
                // let cache;
                // if(images != undefined && images.length > 0){
                //     cache = images.find(i => i.imghash == parametros && i.endpoint == dados.endpoint);
                // }
                // if(cache){
                //     resolve(cache.response);
                // } else {
                    WsImage(config).get(
                        dados.modulo+'/'+dados.versao+'/'+dados.endpoint+ (parametros != null ? ('/'+parametros) : ''),
                    ).then(async function(response){
                        await idb.loadBlob('images', {
                            "endpoint": dados.endpoint,
                            "imghash" : parametros,
                            "response": response
                        });
                        resolve(response);
                    }, error => {
                        reject(error);
                    });
                // }
            } else if (method == 'TESTE'){
                wsTeste().get(
                    ''
                ).then(response => {
                    resolve(response);
                }, error => {
                    reject(error);
                });
            }
        });
    } else {
        router.push("/internet");
        return new Promise((reject) => {
            reject("Sem internet!");
        });
    }
}

function getInfos() {
    'use strict';
    
    var module = {
        options: [],
        header: [navigator.platform, navigator.userAgent, navigator.appVersion, navigator.vendor, window.opera],
        dataos: [
            { name: 'Windows Phone', value: 'Windows Phone', version: 'OS', id: 3 },
            { name: 'Windows', value: 'Win', version: 'NT', id: 3 },
            { name: 'iPhone', value: 'iPhone', version: 'OS', id: 1 },
            { name: 'iPad', value: 'iPad', version: 'OS', id: 1 },
            { name: 'Kindle', value: 'Silk', version: 'Silk', id: 2 },
            { name: 'Android', value: 'Android', version: 'Android', id: 0 },
            { name: 'PlayBook', value: 'PlayBook', version: 'OS', id: 2 },
            { name: 'BlackBerry', value: 'BlackBerry', version: '/', id: 2 },
            { name: 'Macintosh', value: 'Mac', version: 'OS X', id: 5 },
            { name: 'Linux', value: 'Linux', version: 'rv', id: 4 },
            { name: 'Palm', value: 'Palm', version: 'PalmOS', id: 2 }
        ],
        databrowser: [
            { name: 'Chrome', value: 'Chrome', version: 'Chrome', id: 0 },
            { name: 'Firefox', value: 'Firefox', version: 'Firefox', id: 0 },
            { name: 'Safari', value: 'Safari', version: 'Version', id: 0 },
            { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE', id: 0 },
            { name: 'Opera', value: 'Opera', version: 'Opera', id: 0 },
            { name: 'BlackBerry', value: 'CLDC', version: 'CLDC', id: 0 },
            { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla', id: 0 }
        ],
        init: function () {
            var agent = this.header.join(' '),
                os = this.matchItem(agent, this.dataos),
                browser = this.matchItem(agent, this.databrowser);
            
            return { os: os, browser: browser };
        },
        matchItem: function (string, data) {
            var i = 0,
                j = 0,
                regex,
                regexv,
                match,
                matches,
                version;
            
            for (i = 0; i < data.length; i += 1) {
                regex = new RegExp(data[i].value, 'i');
                match = regex.test(string);
                if (match) {
                    regexv = new RegExp(data[i].version + '[- /:;]([\\d._]+)', 'i');
                    matches = string.match(regexv);
                    version = '';
                    if (matches) { if (matches[1]) { matches = matches[1]; } }
                    if (matches) {
                        matches = matches.split(/[._]+/);
                        for (j = 0; j < matches.length; j += 1) {
                            if (j === 0) {
                                version += matches[j] + '.';
                            } else {
                                version += matches[j];
                            }
                        }
                    } else {
                        version = '0';
                    }
                    return {
                        name: data[i].name,
                        version: parseFloat(version),
                        id: data[i].id,
                    };
                }
            }
            return { name: 'unknown', version: 0, id: 2 };
        }
    };
    
    var e = module.init();
    return {
        "os_name": e.os.name,
        "os_version": e.os.version,
        "os_id": e.os.id,
        "browser_name": e.browser.name,
        "browser_version": e.browser.version,
        "navigator_useragent": navigator.userAgent,
        "navigator_appversion": navigator.appVersion,
        "navigator_platform": navigator.platform
    }
}